import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { AutosizeService } from 'app/shared/components/autosize/autosize.service';

declare var $: any;

@Injectable()
export class ModalService {
  private _modalStack: string[] = [];
  public modalShown: ReplaySubject<string> = new ReplaySubject<string>();

  constructor(public autosize: AutosizeService) { }

  show(id: string) {
    this._modalStack.push(id);
    $('#' + id).modal('show');
    this.modalShown.next(id);
    this.autosize.triggerAdjust();
  }

  hide(delay: number = 0) {
    let id = this._modalStack.pop();
    if (id) {
      setTimeout(() => { $('#' + id).modal('hide'); }, delay);
    }
  }

  get modalStack() { return this._modalStack; }
}



// WEBPACK FOOTER //
// /app/src/app/shared/services/modal/modal.service.ts